import counter from './counter'
import icon from './icon'
import rangeSlider from './range-slider'
import menu from '@qpokychuk/wc-menu'

function registerAll() {
  counter.register()
  icon.register()
  rangeSlider.register()
  menu.register()
}

registerAll()
